module.exports = __webpack_public_path__ + "img/icon-favorite.6983c762.svg";